export default "__VITE_ASSET__C5g_ENEg__"